import { useState } from "react";
import { Filter, VisibleOff } from "../../svgUrls";
import { Popover } from "@mui/material";
import DataViewsCustomizeView from "./DataViewsCustomizeView";
import { DataViewCondition, DataViewConfig } from "../../types/dataViews";
import DataViewsFilters from "./DataViewsFilters";
import { MatchingConditionOperator } from "../../constants/common";

type DataViewsHeaderProps = {
    columnVisibility: Record<string, boolean>;
    setColumnVisibility: (visibility: Record<string, boolean>) => void;
    columnOrder: DataViewConfig[];
    nodeIdToService: Record<string, string>;
    overallFilterOperator: MatchingConditionOperator;
    setOverallFilterOperator: (op: MatchingConditionOperator) => void;
    columnsDetails: {
        field_name: string;
        node_id: string | undefined;
        service: string;
    }[];
    emptyCondition: DataViewCondition;
    conditions: DataViewCondition[];
    setConditions: (conditions: DataViewCondition[]) => void;
    applyFilters: () => void;
    onDataViewsUpdate: (_columnOrder: DataViewConfig[]) => void;
}

const DataViewsHeader = ({
    columnVisibility,
    setColumnVisibility,
    columnOrder,
    nodeIdToService,
    overallFilterOperator,
    setOverallFilterOperator,
    columnsDetails,
    emptyCondition,
    conditions,
    setConditions,
    applyFilters,
    onDataViewsUpdate,
}: DataViewsHeaderProps) => {
    // const [showFilters, setShowFilters] = useState(false);
    // const [showCustomizeView, setShowCustomizeView] = useState(false);
    const [filtersAnchorEl, setFiltersAnchorEl] = useState<HTMLDivElement | null>(null);
    const [customizeViewAnchorEl, setCustomizeViewAnchorEl] = useState<HTMLDivElement | null>(null);
    const filtersOpen = Boolean(filtersAnchorEl);
    const customizeViewOpen = Boolean(customizeViewAnchorEl);

    return (
        <div className="flex items-center gap-4 text-xs px-2 mb-4">
            <div className="flex gap-2 items-center cursor-pointer" onClick={(e) => setFiltersAnchorEl(e.currentTarget)}>
                <Filter />
                Filters
            </div>
            <div className="flex items-center gap-2 bg-backgroundGreyLight p-2 rounded-lg cursor-pointer" onClick={(e) => setCustomizeViewAnchorEl(e.currentTarget)}>
                <VisibleOff />
                Hidden fields
            </div>
            <Popover
                open={filtersOpen}
                anchorEl={filtersAnchorEl}
                onClose={() => setFiltersAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
            >
                <DataViewsFilters
                    overallFilterOperator={overallFilterOperator}
                    setOverallFilterOperator={setOverallFilterOperator}
                    columnsDetails={columnsDetails}
                    closeFilters={() => setFiltersAnchorEl(null)}
                    emptyCondition={emptyCondition}
                    conditions={conditions}
                    setConditions={setConditions}
                    applyFilters={applyFilters}
                />
            </Popover>
            <Popover
                open={customizeViewOpen}
                anchorEl={customizeViewAnchorEl}
                onClose={() => setCustomizeViewAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
            >
                <DataViewsCustomizeView
                    columnVisibility={columnVisibility}
                    setColumnVisibility={setColumnVisibility}
                    columnOrder={columnOrder}
                    nodeIdToService={nodeIdToService}
                    onDataViewsUpdate={onDataViewsUpdate}
                />
            </Popover>
        </div>
    )
}

export default DataViewsHeader;